/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateContactEmailRequest
 */
export interface UpdateContactEmailRequest {
    /**
     * Email to update contact email
     * @type {string}
     * @memberof UpdateContactEmailRequest
     */
    contactEmail: string;
    /**
     * Username for account.
     * @type {string}
     * @memberof UpdateContactEmailRequest
     */
    username: string;
    /**
     * The nonce returned from the account creation API.
     * @type {string}
     * @memberof UpdateContactEmailRequest
     */
    creationNonce: string;
}

/**
 * Check if a given object implements the UpdateContactEmailRequest interface.
 */
export function instanceOfUpdateContactEmailRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contactEmail" in value;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "creationNonce" in value;

    return isInstance;
}

export function UpdateContactEmailRequestFromJSON(json: any): UpdateContactEmailRequest {
    return UpdateContactEmailRequestFromJSONTyped(json, false);
}

export function UpdateContactEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateContactEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contactEmail': json['contactEmail'],
        'username': json['username'],
        'creationNonce': json['creationNonce'],
    };
}

export function UpdateContactEmailRequestToJSON(value?: UpdateContactEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contactEmail': value.contactEmail,
        'username': value.username,
        'creationNonce': value.creationNonce,
    };
}

